import { FunctionComponent, ReactNode } from 'react'

import styled from '@emotion/styled'

import { Text } from '@cash-design-system/react'

const StyledError = styled.div`
  margin-top: ${props => props.theme.pxToRem(40)};
  text-align: center;
`

interface Props {
  children?: ReactNode
}

export const ErrorMessage: FunctionComponent<Props> = ({ children }) =>
  children ? (
    <StyledError>
      <Text typography="labelMedium" color="textDanger">
        {children}
      </Text>
    </StyledError>
  ) : null
